/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The OperationalScopePostRequestDTO model module.
 * @module model/OperationalScopePostRequestDTO
 * @version v0
 */
export class OperationalScopePostRequestDTO {
  /**
   * Constructs a new <code>OperationalScopePostRequestDTO</code>.
   * @alias module:model/OperationalScopePostRequestDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>OperationalScopePostRequestDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OperationalScopePostRequestDTO} obj Optional instance to populate.
   * @return {module:model/OperationalScopePostRequestDTO} The populated <code>OperationalScopePostRequestDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OperationalScopePostRequestDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('tooltip'))
        obj.tooltip = ApiClient.convertToType(data['tooltip'], 'String');
      if (data.hasOwnProperty('controlFunctionIds'))
        obj.controlFunctionIds = ApiClient.convertToType(data['controlFunctionIds'], ['Number']);
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
OperationalScopePostRequestDTO.prototype.id = undefined;

/**
 * @member {String} name
 */
OperationalScopePostRequestDTO.prototype.name = undefined;

/**
 * @member {Boolean} active
 */
OperationalScopePostRequestDTO.prototype.active = undefined;

/**
 * @member {Array.<Number>} controlFunctionIds
 */
OperationalScopePostRequestDTO.prototype.controlFunctionIds = undefined;

/**
 * @member {String} tooltip
 */
 OperationalScopePostRequestDTO.prototype.tooltip = undefined;
